import { PaymentProvidersCode } from '@tiendanube/common/src/domains/payments/providers/PaymentProvidersCode';
import { FS_NUVEMPAGO_NEW_PROVIDER_CONFIGURATION_ENABLED } from 'App/featuresFlags';
import { useNavegate } from 'App/hooks';
import goToAdmin from 'commons/utils/gotToAdmin';
import { useNuvemPagoFeatureFlagQuery } from 'domains/NuvemPagoCommons/nuvemPagoCommonsApi';

function useGetPaymentProviderSettingsRoute(id: string) {
  const { goTo } = useNavegate();
  const { data: isFeatureEnabled } = useNuvemPagoFeatureFlagQuery(
    FS_NUVEMPAGO_NEW_PROVIDER_CONFIGURATION_ENABLED,
  );

  const goToSettingsPage = () => {
    switch (id) {
      case PaymentProvidersCode.nuvemPago:
        return isFeatureEnabled
          ? goTo('/nuvempago#/settings')
          : goToAdmin('/nuvempago/settings')();
      case PaymentProvidersCode.pagoNube:
        return goTo('/nuvempago/#/config');
      default:
        return goTo(`/settings/payments/${id}`);
    }
  };

  return { goToSettingsPage };
}

export default useGetPaymentProviderSettingsRoute;
